module.exports = __webpack_public_path__ + "media/images/edit_pencil-8cc4b9779b032449cee372a8a31816e5.svg";